import React from "react";
import { Box, Card, Typography } from "@mui/material";
import PHONE from "../assets/icons/phone.png";
import EMAIL from "../assets/icons/email.png";
import POSITION from "../assets/icons/chair.png";
import LOC from "../assets/icons/map.png";

/* ============================================================================
<CandidateInformationSection />
============================================================================= */
const CandidateInformationSection = ({ interview, extracted_data }) => {
  return (
    <Card
      sx={{
        p: interview ? 0 : 3,
        gap: 4,
        border: 1,
        borderColor: interview ? "transparent" : "#E7E7E7",
        boxShadow: interview ? "none" : "0px 4px 6px rgba(0, 0, 0, 0.1)", // Removes shadow
        display: "flex",
        bgcolor: "transparent",
        justifyContent: "space-between",
        alignItems: interview ? "left" : "center",
        flexDirection: interview ? "column" : "row",
        mb: 2,
      }}
    >
      {/* Phone Number */}
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <img
          src={PHONE}
          height={interview ? 30 : 35}
          style={{ marginTop: 4 }}
        />
        <Box>
          <Typography
            variant="caption"
            color="#9DAcB8"
            display="block"
            fontWeight={500}
          >
            Phone No
          </Typography>
          <Typography fontWeight={600} fontSize="12px" maxWidth="350px">
            {extracted_data?.phone?.value
              ? extracted_data?.phone?.value
              : extracted_data?.personal_info?.phone || "--"}
          </Typography>
        </Box>
      </Box>

      {/* Email */}
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <img
          src={EMAIL}
          height={interview ? 25 : 30}
          style={{ marginTop: 4 }}
        />

        <Box>
          <Typography
            variant="caption"
            color="#9DAcB8"
            display="block"
            fontWeight={500}
          >
            Email
          </Typography>
          <Typography fontWeight={600} fontSize="12px" maxWidth="300px">
            {extracted_data?.candidate_email
              ? extracted_data?.candidate_email
              : extracted_data?.email}
          </Typography>
        </Box>
      </Box>

      {/* Current Position */}
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <img
          src={POSITION}
          height={interview ? 30 : 35}
          style={{ marginTop: 4 }}
        />
        <Box>
          <Typography
            variant="caption"
            color="#9DAcB8"
            display="block"
            fontWeight={500}
          >
            Current Position
          </Typography>
          <Typography
            fontWeight={600}
            fontSize="12px"
            maxWidth="350px"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 4,
            }}
          >
            {extracted_data?.current_position?.value || "--"}
          </Typography>
        </Box>
      </Box>

      {/* Address */}
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <img src={LOC} height={interview ? 30 : 35} style={{ marginTop: 4 }} />

        <Box>
          <Typography
            variant="caption"
            color="#9DAcB8"
            display="block"
            fontWeight={500}
          >
            Address
          </Typography>
          <Typography
            fontWeight={600}
            fontSize="12px"
            maxWidth="350px"
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 4,
            }}
          >
            {extracted_data?.address?.value
              ? extracted_data?.address?.value
              : extracted_data?.personal_info?.address ||
                extracted_data?.location?.value ||
                "--"}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
/* Export
============================================================================= */
export default CandidateInformationSection;
